import React from 'react';

import { Avatar } from '@mui/material';
import { Box } from '@mui/system';

// eslint-disable-next-line import/no-unresolved
import { MessageProfileProps } from '@sendbird/uikit-react/types/ui/MessageContent/MessageProfile';

import { chatActiveTab, ClientChatTypes } from '@pharmaplan/common';

import { useAppSelector } from '../../../../hooks/useAppSelector';
import useAdmin from '../../../../hooks/useAdmin';
import useSelfService from '../../../../hooks/useSelfService';

import styles from './styles';

type senderTypeCast = {
  sender?: {
    profileUrl: string;
    userId: string;
  };
};

const ppUrl = 'https://app.pharmaplan.ca/logo192.png';
const pgUrl = 'https://app.pharmagap.com/logo192.png';

const { pharmacist, pharmacy } = ClientChatTypes;

const SenderProfile = (props: MessageProfileProps) => {
  const { isAdmin } = useAdmin();
  const { isSelfService } = useSelfService();

  const activeTab = useAppSelector(chatActiveTab);
  const isNotSupport = activeTab === pharmacist || activeTab === pharmacy;

  const { message } = props ?? {};
  const { sender } = (message as senderTypeCast) ?? {};
  const { profileUrl } = sender ?? {};

  const appUrl = isSelfService ? pgUrl : ppUrl;

  return (
    <Box sx={styles.senderContainer}>
      <Avatar
        imgProps={{
          sx: styles.img,
        }}
        sx={styles.avatar}
        src={isAdmin || isNotSupport ? profileUrl : appUrl}
      />
    </Box>
  );
};

export default SenderProfile;
